import { render, staticRenderFns } from "./v-accordion.vue?vue&type=template&id=3296edcb&"
import script from "./v-accordion.vue?vue&type=script&lang=js&"
export * from "./v-accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports